import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiHandlerService } from '../api-handler.service';

declare let $:any;

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit, OnDestroy {

  page: number = 1;
  limit: number = 20;
  listCount: number = 0;
  eventList: Array<any> = [];
  constructor(private apiHandler: ApiHandlerService) { }

  ngOnInit() {
    $(window).scrollTop(0, 0)
    window.addEventListener('scroll', this.getEventsOnScroll, true);
    this.getEventList();
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.getEventsOnScroll, true);
  }

  getEventsOnScroll = (event:any): void => {
    let ele = event.srcElement.scrollingElement;
    if (ele != undefined && ele.scrollHeight != undefined && ele.scrollHeight - ele.scrollTop <= ele.clientHeight+100) {
      if(this.listCount == this.limit){
        this.page++;
        this.getEventList()
      }
    }
  };

  getEventList(){
    let obj = {
      page: this.page,
      limit: this.limit
    };
    this.apiHandler.getEventListService(obj).subscribe(
      (res:any)=>{
        if(res.success){
          this.listCount = res.data.length;
          let list = res.data;
          list.map((item:any) =>{
            const index = this.eventList.findIndex(p=>p._id==item._id);
            if(index == -1){
              this.eventList.push(item)
            }
          })
        }
        
      },
      (err:any)=>{

      }
    )
  }

  getDuration(duration:number){
    if(duration/60 >= 1){
      let unit = " Hour";
      if(duration/60 > 1){
        unit = " Hours"
      }
      return parseFloat((duration/60).toExponential(2))+ unit
    }
    else return duration + ' Minutes'
  }

  isEventCompleted(date:Date){
    return new Date(date) < new Date();
  }

}
